import type { Component } from 'solid-js'
import { Trans } from '@mbarzda/solid-i18next'
import type { SegmentInfo, UserSegment } from '../../../features/engagement/domain/models/sections'
import Tooltip from '../../shared/components/Tooltip'
import ToggleGroup, { type ToggleGroupOption } from './ToggleGroup'

interface UserSegmentToggleProps {
  segments: SegmentInfo[]
  value: UserSegment
  onChange: (s: UserSegment) => void
}

// 'All' plus one button per segment; labels come from the API (tier names), not i18n
const buildOptions = (segments: SegmentInfo[]): ToggleGroupOption<UserSegment>[] => [
  { value: 'all', labelKey: 'ls_sections_segment_all' },
  ...segments.map((segment) => ({ value: segment.key, label: segment.label }))
]

const UserSegmentToggle: Component<UserSegmentToggleProps> = (props) => {
  return (
    <Tooltip content={<Trans key={'ls_sections_segment_tooltip'} />}>
      <ToggleGroup options={buildOptions(props.segments)} value={props.value} onChange={props.onChange} />
    </Tooltip>
  )
}

export default UserSegmentToggle
